// Source: game.h (Quake 2)
export enum EntityEffects {
  Rotate = 0x00000004,
  Gib = 0x00000008,
  RotateScript = 0x00000010,
  Blaster = 0x00000020,
  Rocket = 0x00000040,
  Grenade = 0x00000080,
  HyperBlaster = 0x00000100,
  Bfg = 0x00000200,
  ColorShell = 0x00000400,
  Powerscreen = 0x00000800,
  Anim01 = 0x00001000,
  Anim23 = 0x00002000,
  AnimAll = 0x00004000,
  AnimAllFast = 0x00008000,
  Quad = 0x00010000,
  Pent = 0x00020000,
  Explosion = 0x00040000,
  Teleport = 0x00080000,
  Flag1 = 0x00100000,
  Flag2 = 0x00200000,
  Boomerang = 0x00400000,
  Greengibs = 0x00800000,
  Bluehyperblaster = 0x01000000,
  Spinning = 0x02000000,
  Plasma = 0x04000000,
  Trap = 0x08000000,
  Tracker = 0x10000000,
  Double = 0x20000000,
  Sphinx = 0x40000000,
  TagTrail = 0x80000000,
}
